
type MethodWithBody = "POST" | "PATCH" | "PUT" | "DELETE" | "GET";

class Base {
	protected token: string;
	protected apiRoot: string | undefined = import.meta.env.REACT_APP_BASE_API_URL;
	protected restBaseUrl: string;
	private locale: string;
	
	constructor(token: string, restController: string) {
		this.token = token;
		this.restBaseUrl = this.apiRoot + restController;
		this.locale = window.localStorage.getItem("i18nextLng") ?? "no";
	}

	protected get headers(): HeadersInit {
		const headers: HeadersInit = {
			"Content-Type": "application/json",
			Authorization: `Bearer ${this.token}`,
		};

		return headers;
	}

	protected async fetchJson<T>(path: string, method: MethodWithBody, body?: any): Promise<T> {
		const options: any = {
			method,
			headers: this.headers,
		};
		if (body) {
			options.body = JSON.stringify(body);
		}
		const response = await fetch(this.restBaseUrl + path, options);

		if (!response.ok) {
			const error = await response.json();
			throw new Error(`[${response.status}]: ${error.detail ?? error.message}`);
		}

		return await response.json();
	}

	protected async fetchJsonWithQueryParams<T>(
		path: string,
		method: MethodWithBody,
		params?: any,
	): Promise<T> {
		const options: any = {
			method,
			headers: { ...this.headers, "Accept-Language": this.locale },
		};

		const urlParams = new URLSearchParams(params);

		const response = await fetch(this.restBaseUrl + path + urlParams, options);

		if (!response.ok) {
			const error = await response.json();
			throw new Error(`[${response.status}]: ${error.detail ?? error.message}`);
		}

		return await response.json();
	}

	protected async postJsonWithQueryParams<T>(
		path: string,
		method: MethodWithBody,
		body?: any,
		params?: any,
	): Promise<T> {
		try {
			const options: any = {
				method,
				headers: { ...this.headers, "Accept-Language": this.locale  },
			};
			
			if (body) {
				options.body = JSON.stringify(body);
			}
			
			const urlParams = new URLSearchParams(params);
			const response = await fetch(this.restBaseUrl + path + urlParams, options);
	
			if (!response.ok) {
				const error = await response.json();
				throw new Error(`${error.detail ?? error.message}`);
			}

			return await response.json();
		} catch (error: any) {
			return error;
		}
	}

	protected async fetchText(path: string, method: MethodWithBody, body?: any): Promise<string> {
		const options: any = {
			method,
			headers: { ...this.headers, "Content-Type": "text/plain" },
		};
		if (body) {
			options.body = JSON.stringify(body);
		}
		const response = await fetch(this.restBaseUrl + path, options);
		return await response.text();
	}

	protected async fetchNoContent(path: string, method: MethodWithBody, body?: any): Promise<Response> {
		const options: any = {
			method,
			headers: this.headers,
		};
		if (body) {
			options.body = JSON.stringify(body);
		}
		const response = await fetch(this.restBaseUrl + path, options);
		return response;
	}
}

export default Base;
